module.exports = __webpack_public_path__ + "static/media/42.53da7ea5.png";